export const loadingWhitMessageIS = {
	loading: false,
	message: '',
};
